import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import config from '../../../config';
import './style.scss';
import { EcoSystemImage } from './ecosystem';
import { HowWorksImage } from './howworks';
import abountImage from './about.webp';
import msg1 from './msg1.webp';
import msg2 from './msg2.webp';

import kuvoForVenues from './kuvo-for-venues.webp';
import kuvoForCMOs from './kuvo-for-cmos.webp';
import kuvoForEvent from './kuvo-for-event.webp';
import techChartImagePC from './tech_chart_pc.webp';
import techChartImageSP from './tech_chart_sp.webp';
import techChartImageESPC from './tech_chart_es_pc.webp';
import techChartImageESSP from './tech_chart_es_sp.webp';
import techChartImageNLPC from './tech_chart_nl_pc.webp';
import techChartImageNLSP from './tech_chart_nl_sp.webp';

import partnersImagePC from './partners_pc.webp';
import partnersImageSP from './partners_sp.webp';
import news1 from '../NewsPage/news1.webp';
import news2 from '../NewsPage/news2.webp';
import { useApp } from '../../../contexts/AppContext';
import { BreakLines } from '../../atoms/CommonParts';
import { useLang, withLang } from '../../../i18n/langPath';

const Page = styled.div`
  position: relative;
  z-index: 1;
  @media ${config.layout.topwide} {
  }
`;

const FG = styled.div`
  position: relative;
  z-index: 2;
`;

const TopSection = styled.section`
  height: 100vh;
  margin-top: -55px;
  width: 100%;
  position: relative;

  @media ${config.layout.topwide} {
    margin-top: calc(-160px - 34px);
  }
`;

const TopSectionContents = styled.div`
  position: absolute;
  left: 20px;
  top: calc(55px + 50px);

  @media ${config.layout.topwide} {
    left: unset;
    right: 50px;
    top: calc(160px + 34px + 70px);
  }

  h1 {
    font-weight: 300;
    color: #fff;
    font-size: 48px;
    line-height: 48px;
    @media ${config.layout.topwide} {
      font-size: 50px;
      line-height: 72px;
      text-align: right;
      padding-right: 40px;
    }
  }

  p {
    margin-top: 25px;
    font-size: 14px;
    color: #fff;
    width: 280px;
    line-height: 22px;
    white-space: pre-wrap;
    @media ${config.layout.topwide} {
      margin-top: 30px;
      width: 440px;
      position: absolute;
      right: 0;
      font-size: 18px;
      line-height: 28px;
    }
  }
`;

const AboutSection = styled.section`
  background-color: #f8f8f8;
  padding-top: 65px;

  @media ${config.layout.topwide} {
    padding-top: 150px;
  }
`;

const AboutDescriptionArea = styled.div`
  position: relative;

  h2.sp {
    padding: 0 20px;
    font-size: 50px;
    font-weight: bold;
    line-height: 66px;
  }

  @media ${config.layout.topwide} {
    display: flex;
    align-items: flex-start;
  }
`;

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  margin-top: 27px;
  @media ${config.layout.topwide} {
    width: 50%;
    margin-top: unset;
    border-radius: 0px 8px 8px 0px;
  }
`;

const AboutDescription = styled.div`
  padding: 0 20px;

  p {
    margin-top: 1em;
    font-size: 20px;
    font-weight: 400;
    line-height: 31px;
    margin-bottom: 0;
    color: #4a4a4a;
  }

  h3 {
    margin-top: 36px;
    font-weight: bold;
    font-size: 32px;
    line-height: 32px;
    text-align: left;
    color: #000;
    margin-bottom: 30px;
  }

  @media ${config.layout.topwide} {
    width: 50%;
    padding-left: 50px;
    padding-right: 50px;

    h2.pc {
      font-size: 70px;
      font-weight: bold;
      line-height: 130px;
      position: relative;
    }

    h3 {
      margin-top: 27px;
      line-height: 32px;
      margin-bottom: 33px;
    }

    p {
      margin-top: 1em;
      font-size: 22px;
      line-height: 34px;
    }
  }
`;

const EcosystemSection = styled.section``;

const EcosystemSectionPreArea = styled.div`
  padding: 90px 20px 50px;
  background-color: #f8f8f8;

  h3 {
    font-size: 32px;
    font-weight: bold;
    line-height: 43px;
  }

  p {
    margin: 32px 0 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #4a4a4a;
  }

  @media ${config.layout.topwide} {
    padding: 140px 50px 50px;
  }
`;

const ScrollIconWrap = styled.div`
  position: absolute;
  bottom: 0;
  left: 20px;
  height: 100px;

  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 1px;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.3);
  }

  @media ${config.layout.topwide} {
    height: 160px;
    left: 50px;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 1px;
    height: 20px;
    background-color: rgba(255, 255, 255, 1);
  }
`;

const ScrollIconCursor = styled.div`
  height: 20px;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  padding-left: 10px;
  position: relative;
`;

const HowWorksSection = styled.section``;

const HowWorksSectionPreArea = styled.div`
  padding: 90px 20px 50px;
  background-color: #f8f8f8;

  h3 {
    font-size: 32px;
    font-weight: bold;
    line-height: 43px;
  }

  p {
    margin: 32px 0 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #4a4a4a;
  }

  @media ${config.layout.topwide} {
    padding: 140px 50px 50px;
  }
`;

const HowWorksImageArea = styled.div`
  height: 600px;
  background-color: rgba(0, 0, 0, 0.7);
  @media ${config.layout.topwide} {
    height: 700px;
  }
`;

const TechHowWorksSection = styled.section`
  .tech-how-works-header {
    background-color: #f8f8f8;

    padding: 90px 20px 50px;
    @media ${config.layout.wide} {
      padding: 70px 50px 50px;
    }

    & > h4 {
      font-size: 32px;
      line-height: 43px;
      font-weight: bold;
    }

    .description {
      margin-top: 32px;
      font-size: 16px;
      line-height: 26px;
      font-weight: 400;
      color: #4a4a4a;

      @media ${config.layout.wide} {
        margin-top: 50px;
      }
    }
  }

  .tech-how-works-charts {
    padding: 0 20px;
    @media ${config.layout.wide} {
      padding: 0 50px;
    }

    .tech-how-works-chart-area {
      position: relative;

      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: -20px;
        width: 20px;
        height: 100%;
        background-color: #f8f8f8;

        @media ${config.layout.wide} {
          left: -50px;
          width: 50px;
        }
      }

      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        right: -20px;
        width: 20px;
        height: 100%;
        background-color: #f8f8f8;

        @media ${config.layout.wide} {
          right: -50px;
          width: 50px;
        }
      }

      .tech-how-works-chart-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #f8f8f8;
        mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><rect width="100%" height="100%" fill="white"/><rect width="100%" height="100%" rx="8" ry="8" fill="black"/></svg>');
        mask-composite: exclude;
        mask-mode: luminance;
        display: none;

        @media ${config.layout.wide} {
          display: block;
        }
      }

      .chart {
        width: 100%;
        margin-bottom: 0;
        position: relative;

        @media ${config.layout.wide} {
        }
      }
    }
  }

  .tech-how-works-items {
    padding: 44px 20px 70px;
    background-color: #f8f8f8;
    @media ${config.layout.wide} {
      padding: 40px 50px 70px;
    }
  }
`;

const TechHowWorksItems = styled.div`
  @media ${config.layout.wide} {
    display: flex;
  }
`;

const TechHowWorksItem = styled.div`
  @media ${config.layout.wide} {
    margin-top: 0;
    width: 50%;
    flex: 0 0 auto;
    padding-right: 30px;
    &:last-child {
      padding-right: 0;
      padding-left: 30px;
      border-left: 1px solid #000;
    }
  }

  h5 {
    font-size: 24px;
    font-weight: bold;
    line-height: 32px;
    margin-bottom: 20px;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #4a4a4a;
  }
`;

const MessageSection = styled.section`
  background-color: #f8f8f8;
  padding-bottom: 70px;
  border-bottom: 1px solid #d9d9d9;

  padding-top: 20px;
  @media ${config.layout.topwide} {
    padding-top: 0px;
  }

  .msg-img1-sp {
    display: block;
    width: 100%;
    @media ${config.layout.topwide} {
      display: none;
    }
  }

  h3 {
    padding: 60px 20px 32px;
    font-size: 32px;
    font-weight: bold;
    line-height: 43px;
    @media ${config.layout.topwide} {
      padding: 70px 50px 50px;
    }
  }
`;

const MessageSubSections = styled.div`
  display: flex;
  flex-direction: column;

  @media ${config.layout.topwide} {
    &.ss1 {
      flex-wrap: wrap;
      max-height: 650px;
    }

    &.ss2 {
      margin-top: 26px;
      flex-direction: row;
      align-items: flex-start;
    }
  }
`;

const MessageSubSection = styled.div`
  @media ${config.layout.topwide} {
    width: 50%;
  }

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    padding: 0 20px;
    margin-bottom: 1.5em;
    color: #4a4a4a;
    @media ${config.layout.topwide} {
      padding: 0 50px;
    }
  }

  img {
    margin-top: 16px;
    width: 100%;
    height: auto;
    display: inline-block;

    @media ${config.layout.topwide} {
      width: 100%;
      margin-top: 0;
    }
  }

  &.s11 {
    order: 2;
    @media ${config.layout.topwide} {
      order: 1;
    }
  }

  &.s12 {
    order: 3;
    @media ${config.layout.topwide} {
      order: 2;
    }
  }

  &.s13 {
    order: 1;
    text-align: right;
    margin-bottom: 40px;
    @media ${config.layout.mobile} {
      display: none;
    }

    @media ${config.layout.topwide} {
      order: 3;
    }

    img {
      @media ${config.layout.topwide} {
        border-radius: 8px 0px 0px 8px;
      }
    }
  }

  &.s21 {
    margin-bottom: 40px;

    img {
      @media ${config.layout.topwide} {
        border-radius: 0px 8px 8px 0px;
      }
    }
  }

  &.s22 {
  }
`;

const ServicesSection = styled.section`
  background-color: #f8f8f8;
  padding: 35px 20px 70px;

  @media ${config.layout.topwide} {
    padding: 78px 50px 70px;
  }

  h2 {
    font-size: 50px;
    font-weight: bold;
    line-height: 66px;
    @media ${config.layout.topwide} {
      font-size: 70px;
      line-height: 90px;
    }
  }
`;

const ServicesPreSection = styled.div`
  margin-top: 27px;
  @media ${config.layout.topwide} {
    margin-top: 33px;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #4a4a4a;
  }
`;

const ServiceItems = styled.div`
  margin-top: 30px;
  @media ${config.layout.topwide} {
    margin-top: 30px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    gap: 0 50px;
  }
`;

const ServiceItem = styled.div`
  margin-bottom: 35px;
  &:last-child {
    margin-bottom: 0;
  }

  @media ${config.layout.topwide} {
    margin-bottom: 0;
    display: grid;
    grid-template-columns: subgrid;
    grid-template-rows: subgrid;
    grid-row: span 4;
  }

  h3 {
    font-size: 32px;
    font-weight: bold;
    line-height: 43px;
  }

  img {
    margin-top: 22px;
    display: inline-block;
    width: 100%;
    height: auto;
    border-radius: 8px;
    @media ${config.layout.topwide} {
      border-radius: 8px;
    }
  }

  .service-description {
    margin-top: 30px;
    margin-bottom: 30px;

    p {
      font-size: 16px;
      font-weight: 400;
      line-height: 26px;
    }
  }

  .dark-button {
    width: 200px;
    @media ${config.layout.topwide} {
      width: 200px;
    }
  }
`;

const PartnersSection = styled.section`
  position: relative;
  @media ${config.layout.topwide} {
  }
  .partners-image {
    display: block;
    width: 100%;
    height: auto;

    &.pc {
      display: none;
    }

    @media ${config.layout.topwide} {
      &.pc {
        display: block;
      }
      &.sp {
        display: none;
      }
    }
  }

  .partners-content {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    h2 {
      font-size: 30px;
      font-weight: bold;
      line-height: 70px;
      color: #fff;
      @media ${config.layout.topwide} {
        font-size: 70px;
        line-height: 130px;
      }
    }

    p {
      font-weight: normal;

      text-align: center;
      color: #fff;
      font-size: 14px;
      line-height: 18px;
      width: 80%;

      @media ${config.layout.topwide} {
        width: 400px;
        font-size: 16px;
        line-height: 26px;
      }
    }

    a {
      margin-top: 20px;
      filter: invert(1);
      font-weight: normal;
      width: 140px;
    }
  }
`;

const NewsSection = styled.section`
  background-color: #f8f8f8;
  padding: 80px 20px 50px;

  @media ${config.layout.topwide} {
    padding: 78px 50px 100px;
  }

  h2 {
    font-size: 50px;
    font-weight: bold;
    line-height: 66px;
    margin-bottom: 40px;
    @media ${config.layout.topwide} {
      font-size: 70px;
      margin-bottom: 70px;
    }
  }
`;

const NewsItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media ${config.layout.topwide} {
    flex-direction: row;
    gap: 50px;
  }
`;

const NewsItem = styled.a`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-decoration: none;
  color: inherit;

  @media ${config.layout.topwide} {
    flex: 1;
    gap: 20px;
    position: relative;
  }

  img {
    width: 100%;
    display: block;
    height: auto;
  }
`;

const NewsItemImage = styled.div`
  width: 100%;
  aspect-ratio: 400 / 210;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  flex: 0 0 auto;
`;

const NewsItemMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  p {
    margin: 0;
    font-weight: normal;
    font-size: 14px;
    line-height: 1;
    text-align: left;
    color: #4a4a4a;

    @media ${config.layout.topwide} {
      font-size: 16px;
    }
  }

  h3 {
    margin: 0;
    position: relative;
    padding-left: 22px;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    text-align: left;
    color: #4a4a4a;

    @media ${config.layout.topwide} {
      font-size: 20px;
      line-height: 26px;
    }

    &::before {
      content: '';
      position: absolute;
      left: 3px;
      top: 9px;
      transform: rotate(-45deg);
      width: 8px;
      height: 8px;
      border-bottom: 1px solid #4a4a4a;
      border-right: 1px solid #4a4a4a;
    }
  }
`;

const NewsShowAllButtonArea = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  @media ${config.layout.topwide} {
    margin-top: 60px;
  }
`;

const LinksSection = styled.section`
  border-top: 1px solid #d9d9d9;
  background-color: #f8f8f8;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

const LinkItem = styled.div`
  width: 50%;
  text-align: center;
  padding: 0 20px 50px;
  @media ${config.layout.topwide} {
    padding-bottom: 100px;
  }

  &:first-child {
    border-right: 1px solid #d9d9d9;
  }

  h3 {
    margin-top: 40px;
    font-size: 30px;
    font-weight: bold;
    line-height: 39px;
    @media ${config.layout.topwide} {
      margin-top: 80px;
      font-size: 70px;
      line-height: 92px;
    }
  }

  p {
    margin-top: 16px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 0;
    height: 60px;
    @media ${config.layout.topwide} {
      margin-top: 20px;
      height: 90px;
      font-size: 16px;
    }
  }

  .dark-button {
    margin-top: 0;
    width: 100%;
    @media ${config.layout.topwide} {
      width: 170px;
    }
  }
`;

function ScrollIcon() {
  const { t } = useTranslation();
  return (
    <ScrollIconWrap className={'top-scroll-wrap'}>
      <ScrollIconCursor className={'top-scroll-cursor'}>
        {t('common.scroll')}
      </ScrollIconCursor>
    </ScrollIconWrap>
  );
}

export default function TopPage() {
  const app = useApp();
  const { t } = useTranslation();
  const lang = useLang();
  const vwRef = useRef(0);
  useEffect(() => {
    app.setTitle('');

    const setVh = () => {
      let vw = window.innerWidth;
      if (vwRef.current && vwRef.current === vw) {
        return;
      }
      vwRef.current = vw;
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      let sdh = 1;
      for (let d of document.getElementsByClassName('service-description')) {
        sdh = Math.max(sdh, d.querySelector('p').clientHeight);
      }
      document.documentElement.style.setProperty('--sdh', `${sdh}px`);
    };

    document.getElementById('body').classList.add('top');
    window.addEventListener('load', setVh);
    window.addEventListener('resize', setVh);
    setVh();
    return () => {
      document.getElementById('body').classList.remove('top');
      window.removeEventListener('load', setVh);
      window.removeEventListener('resize', setVh);
    };
  }, []);

  return (
    <Page>
      <FG>
        <TopSection id={'top-section'}>
          <TopSectionContents>
            <h1>{t('top.heroLine')}</h1>
            <p>{t('top.heroDescription')}</p>
          </TopSectionContents>
          <ScrollIcon />
        </TopSection>
        <AboutSection data-hash={'about'}>
          <AboutDescriptionArea>
            <h2 className={'sp'}>{t('top.aboutHeading')}</h2>
            <AboutImage src={abountImage} />
            <AboutDescription>
              <h2 className={'pc'}>{t('top.aboutHeading')}</h2>
              <h3>{t('top.aboutSubHeading')}</h3>
              <p>
                <BreakLines text={t('top.aboutText')} />
              </p>
              <p>
                <BreakLines text={t('top.aboutText2')} />
              </p>
            </AboutDescription>
          </AboutDescriptionArea>
        </AboutSection>
        <EcosystemSection data-hash={'kuvo-ecosystem'}>
          <EcosystemSectionPreArea>
            <h3>{t('top.ecosystemHeading')}</h3>
            <p>{t('top.ecosystemText')}</p>
          </EcosystemSectionPreArea>
          <EcoSystemImage />
        </EcosystemSection>

        <HowWorksSection data-hash={'how-kuvo-works'}>
          <HowWorksSectionPreArea>
            <h3>{t('top.howWorksHeading')}</h3>
            <p>{t('top.howWorksText')}</p>
          </HowWorksSectionPreArea>
          <HowWorksImage />
        </HowWorksSection>

        <TechHowWorksSection data-hash={'how-kuvo-technology-works'}>
          <div className={'tech-how-works-header'}>
            <h4>{t('topTechHowWorks.heading')}</h4>
            <div className={'description'}>
              {t('topTechHowWorks.description')}
            </div>
          </div>
          <div className={'tech-how-works-charts'}>
            <div className={'tech-how-works-chart-area'}>
              <div className={'tech-how-works-chart-bg'}></div>

              {lang === 'es' ? (
                <>
                  <img src={techChartImageESPC} className={'chart pc'} />
                  <img src={techChartImageESSP} className={'chart sp'} />
                </>
              ) : lang === 'nl' ? (
                <>
                  <img src={techChartImageNLPC} className={'chart pc'} />
                  <img src={techChartImageNLSP} className={'chart sp'} />
                </>
              ) : (
                <>
                  <img src={techChartImagePC} className={'chart pc'} />
                  <img src={techChartImageSP} className={'chart sp'} />
                </>
              )}
            </div>
          </div>
          <div className={'tech-how-works-items'}>
            <TechHowWorksItems>
              <TechHowWorksItem>
                <h5>{t('topTechHowWorks.mrtHeading')}</h5>
                <p>{t('topTechHowWorks.mrtText')}</p>
              </TechHowWorksItem>
              <TechHowWorksItem>
                <h5>{t('topTechHowWorks.dmcHeading')}</h5>
                <p>{t('topTechHowWorks.dmcText')}</p>
              </TechHowWorksItem>
            </TechHowWorksItems>
          </div>
        </TechHowWorksSection>

        <MessageSection data-hash={'message'}>
          <img src={msg1} className={'msg-img1-sp'} />
          <h3>{t('top.messageHeading')}</h3>
          <MessageSubSections className={'ss1'}>
            <MessageSubSection className={'s11'}>
              <p>{t('top.messageP1')}</p>
              <p>{t('top.messageP2')}</p>
              <p>{t('top.messageP3')}</p>
            </MessageSubSection>
            <MessageSubSection className={'s13'}>
              <img src={msg1} />
            </MessageSubSection>
          </MessageSubSections>
          <MessageSubSections className={'ss2'}>
            <MessageSubSection className={'s21'}>
              <img src={msg2} />
            </MessageSubSection>
            <MessageSubSection className={'s22'}>
              <p>{t('top.messageP4')}</p>
              <p>{t('top.messageP5')}</p>
              <p>{t('top.messageP6')}</p>
              <p>{t('top.messageP7')}</p>
            </MessageSubSection>
          </MessageSubSections>
        </MessageSection>
        <ServicesSection data-hash={'services'}>
          <h2>{t('top.servicesHeading')}</h2>
          <ServicesPreSection>
            <p>{t('top.servicesIntro')}</p>
          </ServicesPreSection>
          <ServiceItems>
            <ServiceItem>
              <h3>{t('top.servicesVenuesHeading')}</h3>
              <img src={kuvoForVenues} />
              <div className={'service-description'}>
                <p>{t('top.servicesVenuesText')}</p>
              </div>
              <Link
                className="dark-button center-fixed"
                to={withLang(lang, '/contact/')}
                state={{
                  category: 'New venue account',
                }}
              >
                <span>{t('common.contactUs')}</span>
              </Link>
            </ServiceItem>
            <ServiceItem>
              <h3>{t('top.servicesCmosHeading')}</h3>
              <img src={kuvoForCMOs} />
              <div className={'service-description'}>
                <p>{t('top.servicesCmosText')}</p>
              </div>
              <Link
                className="dark-button center-fixed"
                to={withLang(lang, '/contact/')}
                state={{
                  category: 'CMO account',
                }}
              >
                <span>{t('common.contactUs')}</span>
              </Link>
            </ServiceItem>
            <ServiceItem>
              <h3>{t('top.servicesEventHeading')}</h3>
              <img src={kuvoForEvent} />
              <div className={'service-description'}>
                <p>
                  <Trans
                    i18nKey="top.servicesEventText"
                    components={[<strong key="0" />]}
                  />
                </p>
              </div>
              <Link
                className="dark-button center-fixed"
                to={withLang(lang, '/contact/')}
                state={{
                  category: 'Event account',
                }}
              >
                <span>{t('common.contactUs')}</span>
              </Link>
            </ServiceItem>
          </ServiceItems>
        </ServicesSection>

        <PartnersSection>
          <img src={partnersImagePC} className="partners-image pc" />
          <img src={partnersImageSP} className="partners-image sp" />
          <div className="partners-content">
            <h2>{t('top.partnersHeading')}</h2>
            <p>{t('top.partnersText')}</p>
            <Link
              className="dark-button center-fixed"
              to={withLang(lang, '/partners/')}
            >
              <span>{t('top.partnersLinkLabel')}</span>
            </Link>
          </div>
        </PartnersSection>

        <NewsSection>
          <h2>{t('header.news')}</h2>
          <NewsItems>
            <NewsItem
              href={t('news.newsSample4Url')}
              rel="noopener"
              target="_blank"
            >
              <NewsItemImage style={{ backgroundImage: `url(https://assets.alphatheta.com/wp-content/uploads/2026/10/KUVO-INA_1200x630.jpg)` }} />
              <NewsItemMeta>
                <p>{t('news.newsSample4Date')}</p>
                <h3>{t('news.newsSample4Title')}</h3>
              </NewsItemMeta>
            </NewsItem>
            <NewsItem
              href={t('news.newsSample1Url')}
              rel="noopener"
              target="_blank"
            >
              <NewsItemImage style={{ backgroundImage: `url(${news1})` }} />
              <NewsItemMeta>
                <p>{t('news.newsSample1Date')}</p>
                <h3>{t('news.newsSample1Title')}</h3>
              </NewsItemMeta>
            </NewsItem>
            <NewsItem
              href={t('news.newsSample2Url')}
              rel="noopener"
              target="_blank"
            >
              <NewsItemImage style={{ backgroundImage: `url(${news2})` }} />
              <NewsItemMeta>
                <p>{t('news.newsSample2Date')}</p>
                <h3>{t('news.newsSample2Title')}</h3>
              </NewsItemMeta>
            </NewsItem>
            
          </NewsItems>
          <NewsShowAllButtonArea>
            <Link
              className="dark-button center-fixed"
              to={withLang(lang, '/news/')}
            >
              <span>{t('common.showAll')}</span>
            </Link>
          </NewsShowAllButtonArea>
        </NewsSection>

        <LinksSection>
          <LinkItem>
            <h3>{t('top.linksFaqHeading')}</h3>
            <p>{t('top.linksFaqText')}</p>
            <Link
              className="dark-button center-fixed"
              to={withLang(lang, '/faq/')}
            >
              <span>{t('common.more')}</span>
            </Link>
          </LinkItem>
          <LinkItem>
            <h3>{t('top.linksContactHeading')}</h3>
            <p>{t('top.linksContactText')}</p>
            <Link
              className="dark-button center-fixed"
              to={withLang(lang, '/contact/')}
            >
              <span>{t('common.more')}</span>
            </Link>
          </LinkItem>
        </LinksSection>
      </FG>
    </Page>
  );
}
